<template>
  <div>
    <div v-if="isFullscreen">
      <md-button
        class="md-fab md-dense play-cta-fab align-rel h-left v-center"
        @click="previous()"
      >
        <md-icon>keyboard_arrow_left</md-icon>
      </md-button>

      <md-button
        class="md-fab md-dense play-cta-fab align-rel h-right v-center"
        @click="next()"
      >
        <md-icon>keyboard_arrow_right</md-icon>
      </md-button>

      <moow-button
        :type="['white']"
        btnText="Close"
        @mClick="close()"
        trailingIcon="clear"
        :camel="true"
        class="align-rel h-right v-bottom"
      />
    </div>
    <div v-else class="container media-controls-container">
      <b-row v-if="showVideoButton">
        <b-col id="media-buttons-holder">
          <moow-button
            class="mb-2"
            :type="['white', 'fat']"
            :btnText="i18n_local.show_all_videos"
            @mClick="selectVideos()"
            :camel="true"
            :trailingIcon="videoButtonIcon"
            :disabled="disableVideosBtn"
          />
        </b-col>
      </b-row>  
      <b-row class="">
        <b-col align-self="end">
          <moow-button
            :type="['white', 'fat']"
            :btnText="i18n_local.show_all_images"
            @mClick="selectPhotos()"
            trailingIcon="crop_original"
            :camel="true"
            :disabled="disablePhotosBtn"
          />
        </b-col>
      </b-row>
    </div>
  </div>  
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "previewMediaControls",
  components: {},
  props: {
    isFullscreen: {
      required: true,
    },
    selectedMediaType: {
      required: true,
    },
    disableVideosBtn: {
      default: false,
    },
    disablePhotosBtn: {
      default: false,
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    imagesIcon() {
      return require("../../assets/icons/images_icon.svg");
    },
    videoButtonIcon() {
      if (this.disableVideosBtn) return "videocam_off";
      else return "videocam";
    },
  },
  created(){
  },
  mounted() {
  },
  updated() {
    if(document){
      document.addEventListener("keyup", this.keyPressAction);
      let mediaButtonsHolder = document.getElementById("media-buttons-holder");
      mediaButtonsHolder.addEventListener("mouseenter", this.displayVideo);
      mediaButtonsHolder.addEventListener("mouseleave", this.hideVideo);
    }
  },
  beforeDestroy() {
    if(document){
      document.removeEventListener("keyup", this.keyPressAction);
      let mediaButtonsHolder = document.getElementById("media-buttons-holder");
      mediaButtonsHolder.removeEventListener("mouseenter", this.displayVideo);
      mediaButtonsHolder.removeEventListener("mouseleave", this.hideVideo);
    }
  },
  methods: {
    displayVideo() {
      this.showVideoButton = true;
    },
    hideVideo() {
      this.showVideoButton = false;
    },
    selectPhotos() {
      this.$emit("emitSelectPhotos");
    },
    selectVideos() {
      if (this.disableVideosBtn) return;
      this.$emit("emitSelectVideos");
    },
    next() {
      this.$emit("emitNext");
    },
    previous() {
      this.$emit("emitPrevious");
    },
    close() {
      this.$emit("emitClose");
    },
    open() {
      this.$emit("emitOpen");
    },
    keyPressAction(keyCode) {
      if (this.isFullscreen) {
        switch (keyCode.code) {
          case "ArrowRight":
            this.next();
            break;
          case "ArrowLeft":
            this.previous();
            break;
          case "ArrowDown":
            this.close();
            break;
          case "Escape":
            this.close();
            break;
        }
      }
    },
  },
  filters: {},
  data() {
    return {
      tooltipActive: false,
      showVideoButton: false,
    };
  },
};
</script>
<style scoped>
@import "../../assets/styles/listing-preview.css";
@import "../../assets/styles/global.css";

body {
  font-size: 16px;
}

.pixel-holder {
  max-height: 2px;
  position: absolute;
  z-index: 999999;
}

.cover-video-holder {
  width: 100%;
  height: 100%;
}

.cover-video-container {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 9999;
  height: 100%;
}

#bottom-bar-item-price {
  font-size: 1.5em;
}

.sub-title {
  font-size: 16px;
}

.showCover {
  position: absolute;
  width: 60%;
  bottom: 10px;
  z-index: 1;
  color: white;
  text-align: center;
  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}

.toggleFullScreenBlanket {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
}

.active {
  border: none;
}

.hideCover {
  display: none;
}

#contact-rep-card {
  overflow: hidden;
  position: sticky;
  top: 20px;
}

#inputHorizontal {
  width: 100%;
}

.image {
  opacity: 1;
  /* display: block; */
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: contain;
  transition: 0.5s ease;
  backface-visibility: hidden;
  cursor: pointer;
}

.middle {
  z-index: 2;
  color: black;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  background-color: transparent;
  opacity: 0;
}

.down {
  z-index: 2;
  color: #fafafa;
  border-radius: 20px;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 10px;
  background-color: #1f8efa;
  opacity: 0;
}

.content {
  position: relative;
}

#media-buttons-holder {
  /* display: inline-block; */
}

.media-controls-container {
  right: 1em;
  position: absolute;
  bottom: 1em;
  width: 100%;
  text-align: right;
}

/* .content:hover .image {
    opacity: 0.2;
    background-color:black
  }

  .content:hover .middle {
    opacity: 1;
  }

  .content:hover .down {
    opacity: 1;
  } */
</style>


// WEBPACK FOOTER //
// src/components/listingComponents/previewMediaControls.vue